const $html = document.documentElement
const $body = document.body
const $header = document.getElementById('header')
const $loader = document.getElementById('loader')
const $loaderIntro = document.getElementById('loader-intro')

export {
    $html,
    $body,
    $header,
    $loader,
    $loaderIntro,
}
